import { Result } from "antd";

const ReportError = ({ message }: { message: string }) => (
    <Result status="warning" title="This report could not be loaded" subTitle={message} />
);

export default ReportError;
